import React, { useEffect, useState, useRef } from 'react'
import http from 'axios'
import { Button, Divider, Grid, Icon, IconButton, SwipeableDrawer } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { withStyles } from '@mui/styles'
import { style } from 'styles'
import { Loading, PayPalBanner, QuantitySelector } from 'components'
import { formatNumber } from 'core/lib'
import Product from './Product'
import Reservation from './Reservation'

function CartDrawer({ classes, onToggle }) {
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const { open, products, total } = useSelector(state => state.cart)
	const shop = useSelector(state => state.shop)

	useEffect(() => {
		const checkCart = async() => {
			const cart = await http.post(`${window.__endpoint}/api/cart/check`, {
				product_ids: products.map(product => product.item_id)
			})
			dispatch({ type: 'check@cart', cart: cart, checkQuantity: shop.profiles.ueby_item_quantity_check == 1 })
		}
		if (open && products.length > 0) {
			checkCart()
		}
	}, [open])

	const emptyCart = () => {
		if (window.confirm('Rimuovere tutti i prodotti dal carrello ?')) {
			dispatch({ type: 'removeAll@cart' })
		}
	}

	const proceedOrder = () => {
		dispatch({ type: 'toggle@cart', openState: false })
		navigate('/order/create')
	}

	return (<SwipeableDrawer
		anchor="right"
		open={open}
		onClose={() => dispatch({ type: 'toggle@cart', openState: false })}
		onOpen={() => dispatch({ type: 'toggle@cart', openState: true })}
		classes={{ paper: classes.cartDrawer }}
	>
		<Loading />
		<div className="productsList">
			<Grid container spacing={0}>
				<Grid item xs={3}>
					<IconButton color="primary" aria-label="chiudi" component="span" onClick={() => dispatch({ type: 'toggle@cart', openState: false })}>
						<Icon>cancel</Icon>
					</IconButton>
				</Grid>
				<Grid item xs={9}>
					<h3>Carrello</h3>
				</Grid>
				{/* Prima visualizzo i prodotti */}
				{products.filter(p => String(p.key).slice(0, 12) != 'reservation_').map((product, p) => <Grid key={p} item xs={12}>
					<Product
						product={product}
					/>
					<Divider />
				</Grid>)}
				{/* Poi visualizzo le prenotazioni */}
				{products.filter(p => String(p.key).slice(0, 12) == 'reservation_').map((product, p) => <Grid key={p} item xs={12}>
					<Reservation
						product={product}
					/>
					<Divider />
				</Grid>)}
			</Grid>
			{shop.paypal_banner_flag == 1 && shop.paypal_id != '' && <div style={{ margin: 10 }}>
				<PayPalBanner
					clientId={shop.paypal_id}
					amount={total}
					forceReRender={[total]}
				/>
			</div>}
			<div className="footer">
				{products.length > 0 && <React.Fragment>
					<p>Totale: {formatNumber(total)} €</p>
					<p><Button color="primary" variant="contained" onClick={proceedOrder}>procedi all'ordine</Button></p>
					<p><Button color="primary" onClick={emptyCart}>svuota carrello</Button></p>
				</React.Fragment>}
				{products.length == 0 && <p>
					Il tuo carrello è vuoto
				</p>}
			</div>
		</div>
	</SwipeableDrawer>)
}

export default withStyles(style)(CartDrawer)
